import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import type {
    RequiredTranslatable} from "@@/shared/translations/translation";
import {
    requiredTranslatableZodSchema,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    DiscountCondition} from "../../../conditions/discount-condition";
import {
    discountConditionZodSchema,
} from "../../../conditions/discount-condition";
import type {
    TimePriceStep} from "../../time-price-step/time-price-step-discount";
import {
    timePriceStepZodSchema,
} from "../../time-price-step/time-price-step-discount";
type TimePriceStepDiscountCreateCommand = {
    readonly _id: string;
    readonly _type: "TIME_PRICE_STEP_DISCOUNT_CREATE_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly providerId: ProviderId;
    readonly conditions: DiscountCondition[];
    readonly steps: TimePriceStep[];
    readonly title: RequiredTranslatable;
};

type FactoryParams = Except<
    TimePriceStepDiscountCreateCommand,
    "_id" | "_type" | "_createdAt"
>;
const timePriceStepDiscountCreateCommandFactory = (params: FactoryParams) => {
    const TimePriceStepDiscountCreateCommand: TimePriceStepDiscountCreateCommand =
        {
            ...params,
            _id: generateId({
                prefix: "time_price_step_discount_create_command__",
            }),
            _type: "TIME_PRICE_STEP_DISCOUNT_CREATE_COMMAND",
            _createdAt: nowIsoAndUnix(),
        };
    return TimePriceStepDiscountCreateCommand;
};

const timePriceStepDiscountCreateCommandZodSchema: z.ZodSchema<TimePriceStepDiscountCreateCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("TIME_PRICE_STEP_DISCOUNT_CREATE_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        conditions: z.array(discountConditionZodSchema),
        steps: z.array(timePriceStepZodSchema),
        title: requiredTranslatableZodSchema,
    });

export {
    timePriceStepDiscountCreateCommandFactory,
    timePriceStepDiscountCreateCommandZodSchema,
};
export type {
    TimePriceStepDiscountCreateCommand,
    FactoryParams as TimePriceStepDiscountCreateCommandParams,
};
